import { homeServicesConfig as homeServices } from 'reaxl-home-services';

export const cardHeaders = {
    MONEY_BACK_GUARANTEE: homeServices.moneyBackGuarantee.title,
    VEHICLE_HISTORY_REPORT: 'Vehicle History Report',
    FACTORY_WARRANTY: 'Factory Warranty',
    LIMITED_WARRANTY: 'Limited Warranty',
    WARRANTY: 'Warranty',
    SAFEGUARD: 'Cover My Car Added Protection',
    ADDITIONAL_PROTECTIONS: 'Optional Add-On Protections',
};

export const cardImages = {
    EXPERIAN: '/cm-api/content/static/img/vhr/experian/autocheck-by-experian.png',
    EXPERIAN_INVERSE: '/cm-api/content/static/img/vhr/experian/autocheck-by-experian-inverse.png',
    EXPERIAN_KBB: '/cm-api/content/static/img/vhr/experian/autocheck-by-kbb-stacked.svg',
    EXPERIAN_KBB_INVERSE: '/cm-api/content/static/img/vhr/experian/autocheck-by-kbb-stacked-inverse.svg',
    MONEY_BACK_GUARANTEE_ATC: 'https://content.autotrader.com/content/dam/autotrader/listing/srpvdp/money-back-guarantee.svg',
    MONEY_BACK_GUARANTEE: 'https://content.autotrader.com/content/dam/autotrader/listing/srpvdp/money-back-guarantee-kbb.svg',
    WARRANTY_ATC: 'https://content.autotrader.com/content/dam/autotrader/listing/srpvdp/factory-warranty.svg',
    WARRANTY: 'https://content.autotrader.com/content/dam/autotrader/listing/srpvdp/factory-warranty-kbb.svg',
    SAFEGUARD: 'https://content.autotrader.com/content/dam/autotrader/listing/srpvdp/cover-my-car-logo.png',
    PROTECTION_ATC: 'https://content.autotrader.com/content/dam/autotrader/listing/srpvdp/optional-protections.svg',
    PROTECTION: 'https://content.autotrader.com/content/dam/autotrader/listing/srpvdp/optional-protections-kbb.svg',
};

export const protectedItem = ['GAP Protection', 'Lifetime Powertrain', 'Tires and Wheels', 'Paint Protection'];

export const protectionDisclaimer = 'Not all dealerships will offer certain protection products. Each protection product may not be included with the vehicle purchase price and has an additional cost.';

export const carbStateWarrantyDisclaimer = 'CARB warranties only apply to plug-in hybrid vehicles in states that follow California emission rules. The CARB states include California, Connecticut, Colorado, Delaware, the District of Columbia, Maine, Maryland, Massachusetts, New Jersey, New York, Oregon, Pennsylvania, Rhode Island, Vermont, Washington.';
